import styles from '@activities/gift/GiftSentActivity/components/RefundButton/styles.module.scss';
import GiftOrderApi from '@apis/gift/GiftOrderApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import useToast from '@hooks/ui/useToast';
import ModalContainer from '@modals/ModalContainer';
import { ErrorResponse } from '@models/error';
import { CancelGiftOrderRequest } from '@models/gift';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const GiftCancelModal: ActivityComponentType<CancelGiftOrderRequest> = ({ params }:{params: CancelGiftOrderRequest}) => {
    const { pop, push } = useFlow();
    const toast = useToast();
    const { t } = useTranslation('gift');
    const handleCancel = () => {
        GiftOrderApi.cancelOrder(params)
            .then(() => {
                pop(2);
                push('GiftCanceledModal', {});
            }).catch((e: AxiosError<ErrorResponse>) => {
                toast.error(e.message);
            });
    };
    return (
        <Modal>
            <ModalContainer>
                <Column spacing={32} fullWidth>
                    <Column spacing={8}>
                        <Text size='3xl' fontWeight='bold' className={styles.title}>
                            {t('giftCancelModal.title')}
                        </Text>
                        <Text size='xl' align='center'>
                            {t('giftCancelModal.description')}
                        </Text>
                    </Column>
                    <Row fullWidth spacing={10}>
                        <Button variant='secondary' fullWidth
                            noPadding
                            onClick={pop} >
                            {t('giftCancelModal.cancel')}
                        </Button>
                        <Button fullWidth
                            noPadding
                            onClick={handleCancel}>
                            {t('giftCancelModal.confirm')}
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default GiftCancelModal;
